export default __webpack_public_path__ + "static/media/Pawan Kumar Shrestha.f6fca443.pdf";